import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { url } from 'constants/index';
import { UTCSingleDate } from 'utils/formatter.utils';

import { EntityData, LineupsFixtureSummary } from './types';

interface LineupsSectionProps {
  data: EntityData;
}

export const LineupsSection = ({ data }: LineupsSectionProps) => {
  const fixtures = data.items as LineupsFixtureSummary[];

  if (data.totalItems === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        This player is not used in any lineups.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: fixtures.length > 0 ? 1.5 : 0 }}>
        All lineups where this player is used count:{' '}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {data.totalItems}
        </Box>
      </Typography>
      {fixtures.length > 0 && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Latest fixtures (at most 5) where this player is used in a lineup:
          </Typography>
          {fixtures.map(fixture => (
            <Box
              key={fixture.id}
              sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: 1, mb: 1 }}
            >
              <Typography
                component={Link}
                to={`${url.base_fixtures}/${fixture.id}?tab=Lineups`}
                target="_blank"
                variant="body2"
                sx={{
                  color: 'primary.main',
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Fixture (ID: {fixture.id})
              </Typography>
              {fixture.startDate && (
                <Typography variant="body2" color="text.secondary">
                  Start date (UTC) {UTCSingleDate(fixture.startDate)}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
